import { render } from "./Scrollytelling.vue?vue&type=template&id=0b9f2eb1"
import script from "./Scrollytelling.vue?vue&type=script&lang=js"
export * from "./Scrollytelling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__